<script>
export default {
    data() {
        return {
            current: 0,
            timer: null
        }
    },
    props: {
        items: Array
    },
    methods: {

    },
    mounted() {
        const itemsCount = this.current.length;

        this.timer = setInterval(() => {
            if (this.current === (this.items.length - 1)) {
                this.current = 0;
            } else {
                this.current = this.current + 1;
            }
        }, 1500)
    },
    unmounted() {
        this.timer = null;
    }
}
</script>

<style>

</style>

<template>
    <ul class='w-full overflow-hidden flex flex-nowrap items-stretch pb-2'>
        <li class='text-5xl text-primary font-bold md:text-[70px] min-w-full grow leading-none' v-for="(item, key) in items" :class='{"visible order-1 opacity-100": key === current, "invisible order-2 opacity-0": key !== current}'>{{ item }}</li>
    </ul>
</template>
